// extracted by mini-css-extract-plugin
export default {"sensor":"SensorsFormField_sensor__OMVAQ"};